<template>
  <div class="d-flex flex-column">
    <div class="d-flex justify-space-between">
      <div class="exp-bar__highlight" :style="{ color }"><slot></slot></div>
      <div class="exp-bar__highlight" :style="{ color }">LV {{ level }}</div>
    </div>

    <v-progress-linear :color="color" buffer-value="100" :value="percent" height="24" stream striped>
      <template v-slot:default="{ value }">
        <strong>
          <span class="exp-bar__highlight" :style="{ color }">{{ currentExpValue }} / {{ nextExpValue }}</span>
        </strong>
      </template>
    </v-progress-linear>
  </div>
</template>

<script>
const DEFAULT_EXP_COLOR = "#9155fd";
export default {
  data() {
    return {
      level: "-",
      currentExpValue: "-",
      nextExpValue: "-",
      percent: 0,
      color: DEFAULT_EXP_COLOR, // 진행바 + 텍스트 색 (설정으로 변경 가능)
    };
  },
  mounted() {},
  methods: {
    displayExp(level, currentExpValue, nextExpValue) {
      this.level = level;
      this.currentExpValue = currentExpValue;
      this.nextExpValue = nextExpValue;

      this.percent = Math.ceil((currentExpValue / nextExpValue) * 100);
    },
    setColor(color) {
      this.color = color || DEFAULT_EXP_COLOR;
    },
  },
};
</script>

<style scoped>
.exp-bar__highlight {
  font-size: 24px;
  font-weight: 900;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}
</style>
